import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import { PostRegistroMaquinaTejido } from "../../services/maquinasTejido.services";
import ModalCharge from "../../modal/modalCharge";
import ModalUserTejido from "../../modal/user/modalUserTejido";
import LoadingSpinner from "../../loadingSpinner";

const MaquinasTejido = () => {
  const [isModalChargeOpen, setIsModalChargeOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalFuncionariosOpen, setModalFuncionariosOpen] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [nombreFuncionario, setNombreFuncionario] = useState("");
  const [formikSetFieldValue, setFormikSetFieldValue] = useState(() => () => {});
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    const { descripcion, id_usuario } = values;

    const valuesToSend = {
      descripcion,
      id_usuario: parseInt(id_usuario),
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 3000));
      await PostRegistroMaquinaTejido(valuesToSend);
      setRegistrationSuccess(true);
      resetForm();
      setNombreFuncionario(""); // Limpiar campo visual
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setIsLoading(false);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  return (
    <Box m="20px">
      <Header title="Registro Máquinas" subtitle="Registro Máquina/Operador" />
      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={() => setRegistrationSuccess(false)} />
      )}
      {registrationError && (
        <ModalError open={registrationError} onClose={() => setRegistrationError(false)} error={error} />
      )}

      {/* Modal de selección de operador */}
        <ModalUserTejido
            open={modalFuncionariosOpen}
            onClose={() => setModalFuncionariosOpen(false)}
            onSelectUsuario={(usuario) => {
            formikSetFieldValue("id_usuario", usuario.id);
            setNombreFuncionario(`${usuario.firstname} ${usuario.lastname}`);
            setModalFuncionariosOpen(false);
        }}
        />


      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          descripcion: "",
          id_usuario: ""
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue
        }) => {
          setFormikSetFieldValue(() => setFieldValue); // guardar referencia usable fuera

          return (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Máquina"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.descripcion}
                  name="descripcion"
                  error={!!touched.descripcion && !!errors.descripcion}
                  helperText={touched.descripcion && errors.descripcion}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Operador"
                  onClick={() => setModalFuncionariosOpen(true)}
                  value={nombreFuncionario}
                  name="id_usuario"
                  InputProps={{ readOnly: true }}
                  sx={{ gridColumn: "span 2", cursor: "pointer" }}
                  helperText={touched.id_usuario && errors.id_usuario}
                  error={!!touched.id_usuario && !!errors.id_usuario}
                />
              </Box>

              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  sx={{
                    backgroundColor: "rgb(206, 220, 0)",
                    border: "none",
                    color: "black",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#bac609" },
                  }}
                  variant="contained"
                >
                  Registrar
                </Button>
              </Box>
              <ModalCharge isLoading={isLoading} />
            </form>
          );
        }}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  descripcion: yup.string().required("Máquina requerida"),
  id_usuario: yup.number().required("Operador requerido"),
});

export default MaquinasTejido;
